import React from 'react';
import { Modal, Button } from 'react-bootstrap';

class CountryProfileModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    };

    this.onHide = this.onHide.bind(this);
    this.onShow = this.onShow.bind(this);
  }

  onHide() {
    this.setState({ show: false });
  }

  onShow() {
    this.setState({ show: true });
  }

  render() {
    return (
      <span>
        <Modal show={ this.state.show } onHide={ this.onHide }>
          <Modal.Header closeButton>
            <Modal.Title>
              { this.props.title }
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            { this.props.content }
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={ this.onHide }>
              <small>Close</small>
            </Button>
          </Modal.Footer>
        </Modal>

        <span className="info-row-item" onClick={ this.onShow }>
          { this.props.children }
        </span>
      </span>
    );
  }
}

export default CountryProfileModal;



// WEBPACK FOOTER //
// ./src/components/CountryProfile/Menu/Modal.js